<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="search-line">
      <button-add :pathName="addAliRouterName" :value="addBtnValue" v-if="permissionCodes.indexOf('001009001') !== -1"/>
    </div>
    <table-main :selection=false :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" @toCurrentPage="toCurrentPage" :tableOperationWidth="tableOperationWidth" :operationArr="operationArr" />
  </div>
</template>

<script>
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../../components/Button/ButtonAdd'
import TableMain from '../../../../components/Table/TableMain'
import {api} from '../../../api/ConfigWx'
import {errorHandler} from '../../../../utils/errorHandler'
import {nSuccess} from '../../../../utils/notice'
import {bus} from '../../../../utils/bus'

export default {
  components: {
    TableMain,
    ButtonAdd,
    Breadcrumb},
  name: 'config-wx',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '资源中心',
        name: 'housing-management'
      }, {
        value: '配置管理',
        name: 'wx-config'
      }, {
        value: '微信账户配置'
      }],
      addBtnValue: '添加微信账户',
      addAliRouterName: 'wx-add',
      tableHead: [{
        prop: 'wxAccountName',
        label: '账户名称'
      }, {
        prop: 'wxAppId',
        label: '微信AppId'
      }, {
        prop: 'wxSecret',
        label: '微信Secret'
      }, {
        prop: 'phone',
        label: '联系电话'
      }, {
        prop: 'contact',
        label: '联系人'
      }, {
        prop: 'memo',
        label: '备注'
      }],
      tableData: [],
      tableOperationWidth: '290',
      operationArr: ['current', 'delete']
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getPage()
  },
  methods: {
    getPage () {
      this.$axios.post(api.getWXAccountPage, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map(v => {
              // if (v.authStatus === '0') {
              //   v.authText = '未授权'
              // } else if (v.authStatus === '1') {
              //   v.authText = '已授权'
              // }
              // if (v.authStartTime && v.authEndTime) {
              //   v.authTime = `${v.authStartTime} - ${v.authEndTime}`
              // } else {
              //   v.authTime = '--'
              // }
            })
            this.tableData = data
          }
        })
        .catch(errorHandler('获取子账号列表失败'))
    },
    toCurrentPage (code) {
      this.$router.push({
        path: `/wx_config/current/${code}`
      })
    },
    // 删除支付宝账户
    deleteLine (code) {
      this.$axios.post(api.deleteWXAccountByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.getPage()
          }
        })
        .catch(errorHandler('删除失败'))
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/ConfigurationManagement/ConfigWx/ConfigWx.vue